// Placeholder — CommonLayout is only used for auth + maintenance pages
// which don't render a component-browser sidebar. The upstream Berry
// template piped its /components-overview tree through here; we deleted
// that tree, so this renders nothing.
const Navigation = () => null;

export default Navigation;
